import { userAgent } from "./browser-context";

export const isMobile = /mobile/i.test(userAgent);



// WEBPACK FOOTER //
// ./src/shared/platform-info.ts